// Keep the existing portal's Montserrat typography, outlined panels and theme.
// This feature deliberately does not install a separate application theme.
export const styles = {
  root: { width: '100%', maxWidth: 1120, alignSelf: 'center', pb: 4 },
  header: { mb: 3, px: { xs: 0, md: 1 } },
  panel: { border: '1px solid', borderColor: 'divider', borderRadius: '10px', p: { xs: 2, md: 3 }, mb: 3 },
  row: { display: 'flex', gap: 2, alignItems: 'center', flexWrap: 'wrap' },
  fields: { display: 'grid', gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' }, gap: 2, my: 3 },
  code: { fontFamily: 'monospace', fontSize: { xs: '2rem', md: '2.75rem' }, letterSpacing: '.18em', overflowWrap: 'anywhere', my: 2 },
  record: { borderTop: '1px solid', borderColor: 'divider', py: 2.5, overflowWrap: 'anywhere' },
  metadata: { color: 'text.secondary', fontSize: '0.8125rem', mt: 0.5, overflowWrap: 'anywhere' },
};
